import { Modal } from 'react-bootstrap';

import { REQUIRE_TEAM_ON_UPLOAD } from '../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../helpers/features/featureFlags';
import { userHasPermissionToViewAnyProject } from '../../../helpers/permissions';
import { BUTTON_TYPE, ButtonGroup } from '../../generic';
import Button from '../../generic/Button';
import SelectTeam from '../SelectTeam';
import type { Team } from '../../../../shared/model-typings';

import styles from './ModalTeamAssignment.module.less';

type ModalTeamAssignmentProps = {
  show: boolean;
  onHide: () => void;
  allTeams: Team[];
  selectedTeams: Team[];
  onTeamsSelected: (teams: Team[]) => void;
  onTeamsSelectionImport: () => void;
  hasNextStep?: boolean;
};

const ModalTeamAssignment = (props: ModalTeamAssignmentProps) => {
  const isTeamRequired = useIsFeatureEnabled(REQUIRE_TEAM_ON_UPLOAD);
  return (
    <Modal show={props.show} onHide={props.onHide}>
      <Modal.Header>
        <Modal.Title>
          Assign Project to Teams
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SelectTeam
          allTeams={props.allTeams}
          selectedTeams={props.selectedTeams}
          onTeamsSelected={props.onTeamsSelected}
          isRequired={isTeamRequired}
        />
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <ButtonGroup>
          <Button type={BUTTON_TYPE.SECONDARY} onClick={props.onHide}>Cancel</Button>
          <Button
            type={BUTTON_TYPE.PRIMARY}
            onClick={props.onTeamsSelectionImport}
            isDisabled={(!userHasPermissionToViewAnyProject() || isTeamRequired) && props.selectedTeams.length === 0}
          >
            {props.hasNextStep ? 'Next' : 'Import Projects'}
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTeamAssignment;
